import { render, staticRenderFns } from "./PxBannerGestao.vue?vue&type=template&id=283b453a&scoped=true"
import script from "./PxBannerGestao.vue?vue&type=script&lang=js"
export * from "./PxBannerGestao.vue?vue&type=script&lang=js"
import style0 from "./PxBannerGestao.vue?vue&type=style&index=0&id=283b453a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283b453a",
  null
  
)

export default component.exports